import { render, staticRenderFns } from "./OrderClaimNew.vue?vue&type=template&id=cb3934c6&"
import script from "./OrderClaimNew.vue?vue&type=script&lang=js&"
export * from "./OrderClaimNew.vue?vue&type=script&lang=js&"
import style0 from "./OrderClaimNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports